import moment from 'moment'

// date of birth helpers shared by Personal Details and Assign Diet
//==============================

export const DOB_DISPLAY_FORMAT = 'DD-MM-YYYY'
// first format is used for display, all of them are accepted when typing
export const DOB_INPUT_FORMATS = [DOB_DISPLAY_FORMAT, 'DD/MM/YYYY', 'DD.MM.YYYY', 'DDMMYYYY']
// stored as a plain date, without time or timezone
export const DOB_API_FORMAT = 'YYYY-MM-DD'
export const DOB_MAX_AGE_YEARS = 100

// convert a stored dob to a date-only moment
// handles plain dates ("1989-08-05") and older values saved with time ("1989-08-05T07:21:28.929Z")
export const parseDob = (dob) => {
    if (!dob) return null
    if (moment.isMoment(dob)) return dob.clone().startOf('day')

    const value = String(dob)
    // older values were picked in local time, so read them in local time to keep the picked day
    const date = value.includes('T') ? moment(value) : moment(value, DOB_API_FORMAT, true)

    return date.isValid() ? date.startOf('day') : null
}

export const formatDobForApi = (dob) => {
    const date = parseDob(dob)
    return date ? date.format(DOB_API_FORMAT) : ''
}

// full years between dob and today, or null when there is no valid dob
export const ageFromDob = (dob) => {
    const date = parseDob(dob)
    return date ? moment().diff(date, 'years') : null
}

// no future dates and nothing older than DOB_MAX_AGE_YEARS
export const isDobOutOfRange = (current) => {
    if (!current) return false
    return (
        current > moment().endOf('day') ||
        current < moment().subtract(DOB_MAX_AGE_YEARS, 'years').startOf('day')
    )
}

// while typing, show the date as DD-MM-YYYY: "05081989", "05-081989" and "05/08/1989" all become "05-08-1989"
// only when separators come right after the day or the month ("2808-2002" works too);
// anything else ("5-8-1989") is left as it is
export const formatDobTyping = (text) => {
    if (!/^[\d\-/.]+$/.test(text)) return text

    const groups = text.split(/[-/.]/)
    let typed = 0
    for (const group of groups.slice(0, -1)) {
        typed += group.length
        if (typed !== 2 && typed !== 4) return text
    }

    const digits = groups.join('').slice(0, 8)
    let result = digits.slice(0, 2)
    if (digits.length > 2) result += '-' + digits.slice(2, 4)
    if (digits.length > 4) result += '-' + digits.slice(4)
    return result
}

// a complete typed date in any accepted format, or null when it isn't a valid birth date
export const parseTypedDob = (text) => {
    const date = moment(String(text || '').trim(), DOB_INPUT_FORMATS, true)
    return date.isValid() && !isDobOutOfRange(date) ? date.startOf('day') : null
}
